import { createRoot } from "react-dom/client";
import styles from "./MedalPop.module.less";
import { getLessonMedal, getIntegralMedal } from "api/mine";
import { useEffect, useState, useRef } from "react";
import { showMedalShare } from "./MedalShare";
import { gitShareModalImage } from "api/mine";
import { Toast } from "react-vant";
import DSBridge from "dsbridge";

export const showMedalPop = async (isHome = false) => {
  const modalId = "medal-pop-container";

  const existingModal = document.getElementById(modalId);
  if (existingModal) {
    try {
      document.body.removeChild(existingModal);
    } catch (error) {
      console.warn("Failed to remove existing modal:", error);
    }
  }

  const modalDiv = document.createElement("div");
  modalDiv.id = modalId;
  document.body.appendChild(modalDiv);
  const root = createRoot(modalDiv);

  const destroyModal = () => {
    try {
      root.unmount();
    } catch (error) {
      console.warn("Failed to unmount root:", error);
    }

    try {
      if (document.body.contains(modalDiv)) {
        document.body.removeChild(modalDiv);
      }
    } catch (error) {
      console.warn("Failed to remove modal div:", error);
    }
  };

  const Modal = () => {
    const [medalData, setMedalData] = useState([]);
    const [isCollapsing, setIsCollapsing] = useState(false);
    const loadingRef = useRef(null);
    const shareImgRef = useRef(null);
    const handleMaskClick = (e) => {
      if (e.target === e.currentTarget) {
        destroyModal();
      }
    };

    const getMedalData = async () => {
      const request = isHome ? getIntegralMedal : getLessonMedal;
      const res = await request();
      if (res.code === 200 && res.data?.has_popup === 1) {
        const medals = res.data?.popup_medals || [];
        if (medals.length > 0) {
          if (DSBridge.hasNativeMethod("book.playSVGA")) {
            DSBridge.call(
              "book.playSVGA",
              {
                mode: "MODE_MEDAL_ANIM_PLAY",
              },
              (back) => {
                console.log(back);
                setMedalData(medals);
              }
            );
          } else {
            setMedalData(medals);
          }
        }
      }
    };

    const handleCollapse = () => {
      setIsCollapsing(true);
      // 4个勋章时动画延时处理
      const delay = medalData.length === 4 
        ? 1000 
        : 1000 + (medalData.length - 1) * 1000;
      setTimeout(destroyModal, delay);
    };
    const handleClickShare = async () => {
      if (shareImgRef.current) {
        showMedalShare(shareImgRef.current);
        return;
      }
      loadingRef.current = Toast.loading({
        message: "正在获取分享数据...",
        forbidClick: false,
        duration: 0,
      });

      const postData = {
        medal_layout: Math.min(medalData.length, 4),
      };
      
      for (let i = 0; i < Math.min(medalData.length, 4); i++) {
        postData[`medal_image${i + 1}`] = medalData[i].icon;
        postData[`medal_text${i + 1}`] = medalData[i].title;
      }

      try {
        const res = await gitShareModalImage(postData);
        if (res.code === 200 && loadingRef.current) {
          showMedalShare(res.data);
          shareImgRef.current = res.data;
        } else if (loadingRef.current) {
          Toast.fail(res.message || "分享失败");
        }
      } catch (error) {
        if (loadingRef.current) {
          Toast.fail(error?.message || "分享失败");
        }
      } finally {
        if (loadingRef.current?.clear) {
          loadingRef.current.clear();
          loadingRef.current = null;
        }
      }
    };

    const getMedalBox = () => {
      if (medalData.length > 0 && medalData.length <= 4) {
        if (medalData.length === 3) {
          return (
            <div className={styles[`medal-box-3`]}>
              <div className={styles[`content-box-1`]}>
                <img
                  className={`${styles["cover"]} ${
                    isCollapsing ? styles["fold-and-fly"] : ""
                  }`}
                  src={medalData[0].icon}
                />
                <div className={styles["text"]}>{medalData[0].title}</div>
              </div>
              <div className={styles["bottom-row"]}>
                {medalData.slice(1).map((item, index) => (
                  <div
                    className={styles[`content-box-${index + 2}`]}
                    key={`${index}-medal-box`}
                  >
                    <img
                      className={`${styles["cover"]} ${
                        isCollapsing ? styles["fold-and-fly"] : ""
                      }`}
                      src={item.icon}
                    />
                    <div className={styles["text"]}>{item.title}</div>
                  </div>
                ))}
              </div>
            </div>
          );
        } else if (medalData.length === 4) {
          return (
            <div className={styles[`medal-box-4`]}>
              <div className={styles["grid-row"]}>
                {medalData.slice(0, 2).map((item, index) => (
                  <div
                    className={`${styles[`content-box-grid`]}`}
                    key={`row1-${index}-medal-box`}
                  >
                    <img
                      className={`${styles["cover"]} ${
                        isCollapsing ? styles["fold-and-fly"] : ""
                      }`}
                      src={item.icon}
                    />
                    <div className={styles["text"]}>{item.title}</div>
                  </div>
                ))}
              </div>
              <div className={styles["grid-row"]}>
                {medalData.slice(2, 4).map((item, index) => (
                  <div
                    className={`${styles[`content-box-grid`]}`}
                    key={`row2-${index}-medal-box`}
                  >
                    <img
                      className={`${styles["cover"]} ${
                        isCollapsing ? styles["fold-and-fly"] : ""
                      }`}
                      src={item.icon}
                    />
                    <div className={styles["text"]}>{item.title}</div>
                  </div>
                ))}
              </div>
            </div>
          );
        } else {
          return (
            <div className={styles[`medal-box-${medalData.length}`]}>
              {medalData.map((item, index) => (
                <div
                  className={`${styles[`content-box-${index + 1}`]}`}
                  key={`${index}-medal-box`}
                >
                  <img
                    className={`${styles["cover"]} ${
                      isCollapsing ? styles["fold-and-fly"] : ""
                    }`}
                    src={item.icon}
                  />
                  <div className={styles["text"]}>{item.title}</div>
                </div>
              ))}
            </div>
          );
        }
      }
      return null;
    };

    useEffect(() => {
      getMedalData();
    }, []);

    useEffect(() => {
      if (medalData.length > 0) {
        const url = "https://cdn03.myaitalk.vip/static/voice_congratulation.mp3";
        if (DSBridge.hasNativeMethod("playOnlineSound")) {
          DSBridge.call("playOnlineSound", url, () => {});
        } else {
          const audio = new Audio(url);
          audio.play().catch((e) => console.log(e));
        }
      }
    }, [medalData]);

    return (
      <>
        {medalData.length > 0 ? (
          <div className={styles.modalOverlay} onClick={handleMaskClick}>
            <div className={styles["text-box"]}>
              {Array.from({ length: 9 }).map((_, index) => (
                <img
                  key={`${index}-text-box-item`}
                  className={styles["text-box-item"]}
                  src={require(`@/images/mine/my-medal/text-${index + 1}.png`)}
                />
              ))}
            </div>
            {getMedalBox()}
            <div className={styles["desc-box"]}>
              可以进入我的-勋章墙查看全部勋章
            </div>
            <div className={styles["btn-box"]}>
              <img
                className={styles["btn-box-item"]}
                src={require("@/images/mine/my-medal/close-1.png")}
                onClick={handleClickShare}
              />
              <img
                className={styles["btn-box-item"]}
                src={require("@/images/mine/my-medal/close-2.png")}
                onClick={() => {
                  if (DSBridge.hasNativeMethod("playOnlineSound")) {
                    DSBridge.call("playOnlineSound", "https://cdn02.myaitalk.vip/static/tap.mp3", () => {});
                  } else {
                    const audio = new Audio("https://cdn02.myaitalk.vip/static/tap.mp3");
                    audio.play().catch(e => console.log(e));
                  }
                  handleCollapse();
                }}
              />
            </div>
          </div>
        ) : null}
      </>
    );
  };

  root.render(<Modal />);

  return destroyModal;
};
